import { useSwiper } from 'swiper/react';
import { useEffect } from 'react';
import { useDeviceType, useIntersectionObserver } from '@vfit/shared/hooks';
import { ICarouselStoriesExperienceAnimation } from './CarouselStoriesExperienceAnimation.models';

const CarouselStoriesExperienceAnimation = ({
  containerRef,
}: ICarouselStoriesExperienceAnimation) => {
  const { isMobile } = useDeviceType();
  const sliderStoriesCarouel = useSwiper();
  const entry = useIntersectionObserver(containerRef, {
    rootMargin: isMobile ? '-1%' : '-15%',
    threshold: 0.7,
  });
  const isVisible = !!entry?.isIntersecting;

  const checkAnimation = () => {
    if (!sliderStoriesCarouel?.activeIndex) {
      sliderStoriesCarouel.slideNext(2000);
    }
  };

  useEffect(() => {
    if (isVisible) {
      checkAnimation();
    }
  }, [isVisible]);

  return null;
};

export default CarouselStoriesExperienceAnimation;
